import crudlModuleGenerator from '@/_CRUDL/modules/generator';

const multiple = `/${process.env.VUE_APP_BANKS_API_SUFFIX}/vehicles`;
const single = `/${process.env.VUE_APP_BANKS_API_SUFFIX}/vehicles/:license_plate_code`;

export default crudlModuleGenerator('vehicles', {
  customKeys: {
    create: 'data',
    read: 'data',
    update: 'data',
    delete: 'data',
    list: 'data',
  },
  customEndpoints: {
    create: multiple,
    read: single,
    update: single,
    delete: single,
    list: multiple,
  },
});
